import { PLATFORM_CHAT_ENTITY_TYPE } from '../components/platform-comments-chat/platform-chat-entity.const';

/**
 * Maps a Drive `directoryKind.directoryKindName` to its `PLATFORM_CHAT_ENTITY_TYPE`.
 * `PLAIN` is the project root, so it resolves to `PROJECT`.
 */
const DIRECTORY_KIND_TO_ENTITY_TYPE: Readonly<Record<string, string>> = {
  PLAIN: PLATFORM_CHAT_ENTITY_TYPE.PROJECT,
  SECTION: PLATFORM_CHAT_ENTITY_TYPE.SECTION,
  'SUB-SECTION': PLATFORM_CHAT_ENTITY_TYPE.SUB_SECTION,
  TOPIC: PLATFORM_CHAT_ENTITY_TYPE.FOLDER,
  OPTION: PLATFORM_CHAT_ENTITY_TYPE.SUB_FOLDER,
  VERSION: PLATFORM_CHAT_ENTITY_TYPE.VERSION,
};

/** Resolve a Drive directory kind name to its platform entity type (fallback `PROJECT`). */
export function mapDirectoryKindToEntityType(kindName?: string | null): string {
  return DIRECTORY_KIND_TO_ENTITY_TYPE[kindName ?? ''] ?? PLATFORM_CHAT_ENTITY_TYPE.PROJECT;
}
